'use client';
import useIsDesktop from '@lib/hooks/useIsDesktop';
import { MotionDiv } from '@lib/motion';
import { MenuCategoryType, MenuSectionType } from '@lib/sanity/queries/menu/types';
import Anchor from '@ui/Anchor/Anchor';
import IconType from '@ui/Icon/StaticIcon/IconType';
import { StaticIcon } from '@ui/Icon/StaticIcon/StaticIcon';
import Text, { TextVariant } from '@ui/Text/Text';
import cn from '@utils/cn';

export type LinkProps = {
  title: MenuSectionType['title'];
  menuCategories?: MenuCategoryType[];
  isActive?: boolean;
  url?: string | null;
  useArrowDownIcon?: boolean;
  paddingsClassName?: string;
  className?: string;
  onClick?: () => void;
};

function Link({
  title,
  menuCategories,
  className,
  isActive,
  url,
  useArrowDownIcon,
  paddingsClassName,
  onClick,
  ...rest
}: LinkProps) {
  const isDesktop = useIsDesktop();
  return (
    <MotionDiv
      animate={{
        borderBottomColor: isActive && isDesktop ? 'var(--foreground)' : 'transparent',
      }}
      whileHover={{
        borderBottomColor: isDesktop ? 'var(--foreground)' : 'transparent',
      }}
      className={cn('flex h-full border-b border-b-transparent')}
      onClick={onClick}
    >
      <div className={cn('group h-full w-fit cursor-pointer', className)} {...rest}>
        {menuCategories?.length ? (
          <div className={cn('flex h-full items-center gap-1', paddingsClassName)}>
            <Text
              content={title?.value}
              variant={TextVariant.TextBodyMD}
              as="span"
              className="text-foreground text-link-lg font-medium"
            />
            <div className="relative flex h-full">
              <MotionDiv className="flex h-full items-center" animate={{ rotate: isActive ? 180 : 0 }}>
                <StaticIcon
                  icon={useArrowDownIcon ? IconType.arrowDown : IconType.chevronDown}
                  svgClassName="fill-foreground"
                  className="h-5 w-5"
                />
              </MotionDiv>
            </div>
          </div>
        ) : (
          <Anchor href={url || undefined} className={cn('flex h-full items-center', paddingsClassName)}>
            <Text
              content={title?.value}
              variant={TextVariant.TextBodyMD}
              className="text-foreground text-link-lg font-medium"
            />
          </Anchor>
        )}
      </div>
    </MotionDiv>
  );
}

export default Link;
